import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

import {SignatureMethodSelectComponent} from './signature-method-select.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule
  ],
  declarations: [
    SignatureMethodSelectComponent
  ],
  exports: [
    SignatureMethodSelectComponent
  ]
})
export class SignatureMethodModule {
}
